import React, { useEffect, useState } from 'react';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import TPortafolioMyOrganizations from './TPortafolioMyOrganizations';
import { connect } from 'react-redux';
import { deleteOrganizationsByParentOrganizationId, getAllOrganization, getOrganizationsByParentOrganizationId } from 'src/store/organization/thunks';
import { AppState } from 'src/store';
import TPortafolioOrganizations, { DataTypePortafolio } from './TPortafolioOrganizations';
import TActivityDataPortfolio from './TActivityDataPortfolio';
import { openNotification } from 'src/globals/Components/Notification/Notificaction';
interface UserTableProps {

    getAllOrganization?: any;
    getOrganizationsByParentOrganizationId?: any;

}

const PortafolioOrganization: React.FC<UserTableProps> = (props: UserTableProps) => {
    const [dataTable, setDataTable] = useState([]);
    const [showTable, setShowTable] = useState(true);
    const [showTables, setShowTables] = useState("");
    const [validateOrganizations, setvalidateOrganizations] = useState(true);
    const [organizationObject, setOrganizationObject] = useState<DataTypePortafolio>();
    const init = async () => {        
        const responseDataOrganization = await props.getAllOrganization();
        if (responseDataOrganization.length == 0) {
            openNotification("Advertencia", "El usuario no tiene organizaciones asignadas");
            setvalidateOrganizations(false);
        }
        else {
            setShowTable(true);
            setDataTable(responseDataOrganization);
            setOrganizationObject(responseDataOrganization[0]);

        }

    }
    useEffect(() => {
        init();
    }, []);
    return (
        <div>
            {showTable ?
                <>
                    <AdminHeader>Mis Organizaciones</AdminHeader>
                    {validateOrganizations == true && (
                        <TPortafolioMyOrganizations dataTableOrganization={dataTable} />
                    )}
                </>
                : <>
                    {validateOrganizations == true && (
                        <TPortafolioOrganizations organizationsTable={showTables} organizationObject={organizationObject} />
                    )}

                </>

            }


        </div>

    );
};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllOrganization, getOrganizationsByParentOrganizationId
})(PortafolioOrganization);